// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__YOxOl","activeTab":"Tabs_activeTab__KcOWm","inactiveTab":"Tabs_inactiveTab__1ImyL"};